import React, { Component } from "react";

// import Typography from '@material-ui/core/Typography';

import UserAddFunction from "./userAddFunction";
import { withFirebase } from "../../Firebase";
import { withRouter } from "react-router-dom";
import { compose } from "recompose";
import withAuthorization from "../../Session/withAuthorization";

import Navigation from "../../Navigation";

const UserAddPage = () => {
  return <Navigation content={<UserAddForm />} />;
};

class UserAddPageBase extends Component {
  render() {
    return (
      <>
        <UserAddFunction props={this.props} />
        <label
          variant="caption"
          style={{
            display: "block",
            marginBottom: "auto",
            textAlign: "center",
            fontSize: "12px",
          }}
        >
          Copyright &copy; {new Date().getFullYear()} RAMPVER. All rights
          reserved.
        </label>
      </>
    );
  }
}

const condition = (authUser) => !!authUser;

const UserAddForm = compose(
  withAuthorization(condition),
  withRouter,
  withFirebase
)(UserAddPageBase);

export default UserAddPage;

export { UserAddForm };
